import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { type AccessorialRate } from '../../domain/Accessorial'
import { getAccessorialRates } from '../../use-cases/getAccessorialRates'

type State = {
  accessorialRates: Array<AccessorialRate>
  fetchAccessorialRatesStatus: RequestStatus
}

const initialState = {
  accessorialRates: [],
  fetchAccessorialRatesStatus: RequestStatus.Initial,
}

export function useFetchAccessorialRates() {
  const [{ accessorialRates, fetchAccessorialRatesStatus }, setFetchState] =
    useState<State>(initialState)

  const fetch = useCallback(async (carrierInvite: string, controller: AbortController) => {
    setFetchState({
      accessorialRates: [],
      fetchAccessorialRatesStatus: RequestStatus.Pending,
    })
    try {
      const list = await getAccessorialRates(carrierInvite, controller)

      setFetchState({
        accessorialRates: list,
        fetchAccessorialRatesStatus: RequestStatus.Done,
      })
    } catch (err) {
      if (!controller.signal.aborted) {
        setFetchState({
          accessorialRates: [],
          fetchAccessorialRatesStatus: RequestStatus.Error,
        })
      }
    }
  }, [])

  return {
    accessorialRates,
    fetchAccessorialRates: fetch,
    fetchAccessorialRatesStatus,
  }
}
